import React from 'react'
import PropTypes from 'prop-types'
import { SocialLinks } from 'LiveBoard/components/shared/SellerCard/SocialLinks'
import { ACCESSIBILITY_CLASSES, TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

import './style.css.scss'

export const CONTACT_DETAILS_CLASS = 'seller-contact-details'

const ContactDetails = ({ seller }) => {
  const onEmailClick = (e) => e.stopPropagation()
  return (
    <div className={CONTACT_DETAILS_CLASS}>
      <div className="container-left" >
        <SocialLinks data={seller} />
      </div>
      <div className="container-right">
        <div className="details">
          <a className={`email ${ACCESSIBILITY_CLASSES.main}`}
            href={`mailto:${seller.email}`}
            onClick={onEmailClick}
            tabIndex={TAB_INDEXES.ContactDetailsEmail} >
            <span className="icon-email" />
            <span>{seller.email}</span>
          </a>
          <h2 className="phone">
            {!!seller.phone && <span className="icon-phone" />}
            <span>{seller.phone}</span>
          </h2>
        </div>
      </div>
    </div>
  )
}

ContactDetails.propTypes = {
  seller: PropTypes.object.isRequired
}

export default ContactDetails

